/** Sport-type colors — mirrors Ai-Tempo `IconNames.ts` + bridge `CalendarPanel` SPORT_COLORS. */
export const WORKOUT_TYPE_COLORS: Record<number, string> = {
  1: '#185165', // Run
  2: '#56197f', // Bike
  3: '#087fb3', // Swim
  4: '#851b41', // Brick
  5: 'var(--text-accent)', // Crosstrain
  6: '#1a5063', // Race
  7: '#85969d', // Day Off
  8: '#b36800', // Mountain Bike
  9: '#51164c', // Strength
  10: '#8c1094', // Custom
  11: '#d16039', // XC-Ski
  12: '#19acd7', // Rowing
  13: '#8c1094', // Other
  14: '#ab9f05', // Walk
};

export const WORKOUT_TYPE_ENGLISH: Record<number, string> = {
  1: 'Run',
  2: 'Bike',
  3: 'Swim',
  4: 'Brick',
  5: 'Crosstrain',
  6: 'Race',
  7: 'Day Off',
  8: 'Mountain Bike',
  9: 'Strength',
  10: 'Custom',
  11: 'XC-Ski',
  12: 'Rowing',
  13: 'Other',
  14: 'Walk',
};

const NAME_TO_ID: Record<string, number> = Object.fromEntries(
  Object.entries(WORKOUT_TYPE_ENGLISH).map(([id, name]) => [name.toLowerCase(), Number(id)]),
);

/** Resolve workout type id from english_name or localized name heuristics. */
export function resolveWorkoutTypeId(typeId?: number | null, name?: string | null): number | null {
  if (typeId != null && WORKOUT_TYPE_COLORS[typeId]) return typeId;
  const raw = (name ?? '').trim().toLowerCase();
  if (!raw) return null;

  if (NAME_TO_ID[raw]) return NAME_TO_ID[raw];

  if (raw.includes('mountain') || raw.includes('کوهستان')) return 8;
  if (raw.includes('brick') || raw.includes('چندگانه')) return 4;
  if (raw.includes('crosstrain') || raw.includes('cross train') || raw.includes('ترکیبی')) return 5;
  if (raw.includes('strength') || raw.includes('قدرت')) return 9;
  if (raw.includes('swim') || raw.includes('شنا')) return 3;
  if (raw.includes('walk') || raw.includes('پیاده')) return 14;
  if (raw.includes('row') || raw.includes('قایق')) return 12;
  if (raw.includes('ski') || raw.includes('اسکی')) return 11;
  if (raw.includes('race') || raw.includes('مسابقه')) return 6;
  if (raw.includes('day off') || raw.includes('استراحت')) return 7;
  if (raw.includes('custom') || raw.includes('سفارشی')) return 10;
  if (raw.includes('other') || raw.includes('سایر')) return 13;
  if (raw.includes('run') || raw.includes('دوید')) return 1;
  if (raw.includes('bike') || raw.includes('cycl') || raw.includes('دوچرخ')) return 2;

  return null;
}

export function getWorkoutTypeColor(typeId?: number | null, name?: string | null): string {
  const id = resolveWorkoutTypeId(typeId, name);
  if (id != null) return WORKOUT_TYPE_COLORS[id];
  return '#d97706';
}

export function getWorkoutTypeEnglishName(typeId?: number | null, name?: string | null): string {
  const id = resolveWorkoutTypeId(typeId, name);
  if (id != null) return WORKOUT_TYPE_ENGLISH[id];
  return name ?? 'Other';
}
